/*
<summary>
   This file is used to provide initial values or state to the Process Module Observables.
   Developer:Urvashi, Created Date: 21-November-2024
</summary>
*/
import { IOrderTableListVM } from '../../models/response/IOrderTableResponse';
const initialTrayState: IOrderTableListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  Trays: [],
  SavedColumn: '',
  ProcessList: [],
};

export default initialTrayState;
